<template>
  <div class="v-pre__wrapper" :class="{ [extraClass]: true }">
    <span v-if="label" class="v-pre__label">{{ label }}</span>
    <div class="v-pre__content">
      <div class="v-pre">
        <span> {{ text }} </span>
      </div>
      <VCopyIcon v-if="withCopy" :copyText="text"> </VCopyIcon>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VCopyIcon from "@/components/VCopyIcon";

export default Vue.component("VPre", {
  props: {
    withCopy: VueTypes.bool.def(true),
    label: VueTypes.string,
    text: VueTypes.string.isRequired,
    extraClass: VueTypes.string
  },

  components: {
    VCopyIcon
  }
});
</script>

<style lang="scss" scoped>
.v-pre__label {
  display: flex;
  align-self: start;
  margin-bottom: 14px;
  font-size: 15px;
  font-family: Lato-Bold, Arial, sans-serif;
  color: $main-text-color;
}
.v-pre {
  &__content {
    display: flex;
    align-items: center;
    margin: 0 0 10px;

    img {
      cursor: pointer;
      margin-left: 24px;
    }
  }

  padding: 0 15px;
  min-height: $input-height;
  line-height: 1.42857143;
  font-size: 16px;
  word-break: break-all;
  word-wrap: break-word;
  border-radius: 4px;
  border: 1px solid $primary-border-color;
  color: $secondary-text-color;
  width: 457px;
  max-width: 457px;
  display: flex;
  align-items: center;
  @include textCropEllipsis();

  span {
    @include textCropEllipsis();
    max-width: 95%;
  }

  i {
    cursor: pointer;
    font-size: 18px;
  }
}
</style>
